<template>
  <div
    :key="coachee.id"
    class="flex justify-between items-center grow bg-surface-container p-2 rounded-lg"
  >
    <div class="flex items-center gap-2">
      <BaseMemberAvatar :member="coachee" />
      <p class="text-body-medium text-on-surface-variant">
        {{ $t('coaching.invitation.rejectedDescription', { firstName: coachee.firstName }) }}
      </p>
    </div>
    <BaseButtonGroup class="shrink-0 self-start">
      <BaseTextButton
        color="outlined"
        icon="refresh"
        @click="$emit('resendCoachingInvitation')"
        >{{ $t('coaching.status.rejected.button.resend') }}</BaseTextButton
      >
      <BaseIconButton icon="close" shape="round" width="narrow" color="tonal" @click="openDialog" />
    </BaseButtonGroup>
    <BaseDialog
      type="basic"
      :is-open="isOpen"
      @close="closeDialog"
      :title="$t('coaching.invitation.withdrawDialog.title')"
      :description="$t('coaching.invitation.withdrawDialog.description', { firstName: coachee.firstName })"
    >
      <template #confirm
        ><BaseTextButton @click="$emit('deleteCoaching')"
          >{{ $t('coaching.status.rejected.button.withdraw') }}</BaseTextButton
        ></template
      >
      <template #dismiss
        ><BaseTextButton @click="closeDialog">{{ $t('common.cancel') }}</BaseTextButton></template
      >
    </BaseDialog>
  </div>
</template>

<script setup lang="ts">
import BaseMemberAvatar from '@/core/components/base/avatar/BaseMemberAvatar.vue'
import BaseButtonGroup from '@/core/components/base/button/BaseButtonGroup.vue'
import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'
import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
import { useDialog } from '@/core/components/base/dialog/use-dialog'
import type { Member } from '@/core/models/member/member'

interface Props {
  coachee: Member
}

defineProps<Props>()

defineEmits<{
  (e: 'deleteCoaching'): void
  (e: 'resendCoachingInvitation'): void
}>()

const { isOpen, openDialog, closeDialog } = useDialog()
</script>
